import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getBanner, removeBanner } from 'slice/bannerSlice';
import AdminTable from 'common/AdminTable';
import { FaTrash, FaEdit, FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const BannerList = () => {
    const dispatch = useDispatch()
    const cartData = useSelector((state) => state.banner);
    const navigate = useNavigate();
    const backend = process.env.REACT_APP_BACKEND;

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Selling Price',
            accessor: 'selling_price',
        },
        {
            Header: 'Shipping Charge',
            accessor: 'shipping_charge',
        },
        {
            Header: 'Original Price',
            accessor: 'original_price',
        },
        {
            Header: 'Rating',
            accessor: 'rating',
        },
        {
            Header: 'Stock Qty',
            accessor: 'stock_quantity',
        },
        {
            Header: 'Description',
            accessor: 'description',
        },
        {
            Header: 'Processor',
            accessor: 'processor',
        },
        {
            Header: 'RAM',
            accessor: 'ram',
        },
        {
            Header: 'Storage',
            accessor: 'storage',
        },
        {
            Header: 'Battery Life',
            accessor: 'battery_life',
        },
        {
            Header: 'Weight',
            accessor: 'weight',
        },
        {
            Header: 'Screen Size',
            accessor: 'screen_size',
        },
        {
            Header: 'GPU',
            accessor: 'gpu',
        },
        {
            Header: 'Product ID',
            accessor: 'product_id',
        },
        {
            Header: 'Stock',
            accessor: 'stock',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={`${backend}banner/${row.original.image}`}
                    alt={row.original.name}
                    width={100} 
                />
            ),
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <span className={`badge ${row.original.is_active ? 'badge-success' : 'badge-secondary'}`}>
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button
                        className="btn btn-sm mx-1 text-white"
                        style={{ backgroundColor: '#17a2b8' }}
                        onClick={() => window.open(`${backend}banner/${row.original.image}`, '_blank')}
                    >
                        <FaEye />
                    </button>
                    <button
                        className="btn btn-sm mx-1 text-white"
                        style={{ backgroundColor: '#ffc107' }}
                        onClick={() => navigate(`/banner/update/${row.original.id}`)}
                    >
                        <FaEdit />
                    </button>
                    <button
                        className="btn btn-sm mx-1 text-white"
                        style={{ backgroundColor: '#dc3545' }}
                        onClick={() => {
                            if (window.confirm('Are you sure you want to delete this banner?')) {
                                dispatch(removeBanner(row.original.id));
                            }
                        }}
                    >
                        <FaTrash />
                    </button>
                </>
            ),
        },
    ];

    console.log(cartData)
    useEffect(() => {
        dispatch(getBanner())
    }, [dispatch])

    return (
        <>
            <div className="container-fluid mt-5">
                <div className="mainheadig mx-4">
                    <h4 className="text-white font-weight-bold">Banner List</h4>
                </div>
                {cartData?.data?.length > 0 ? (  
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                ) : (
                    <p>No banner available</p>
                )}
            </div>
        </>
    )
}

export default BannerList;
